import { Box, Divider, Flex, Stack, useColorModeValue as mode } from '@chakra-ui/react';
import DashboardCard from '@components/atoms/DashboardCard';
import Button from '@components/interactive/Button';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import clipboardIcon from '@public/flaticons/clipboard.png';
import Image from 'next/image';

export const SoaCard = () => {
  // Resources
  const { authenticatedUser: user } = useAuthenticatedContextProvider();
  const twentyFourHoursAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);

  const unsignedSoaForFutureAppt = user.user_soas.find(
    (soa) => !soa.completed_at && soa.date_of_appointment && new Date(soa.date_of_appointment) >= twentyFourHoursAgo
  );

  // Hide SOA card if no unfinished SOA within last year exists
  if (!unsignedSoaForFutureAppt) {
    return null;
  }

  return (
    <DashboardCard id="soa-dashboard-card">
      <Stack direction={['column', 'column', 'row']} alignItems={['stretch', 'stretch', 'normal']}>
        <Divider
          opacity={1}
          borderColor={mode('blue.500', 'blue.200')}
          borderWidth="2px"
          height="inherit"
          borderRadius={5}
          orientation="vertical"
          mr={[0, 0, 4]}
          ml={[0, 0, -5]}
          mb={[6, 6, 0]}
          flexDir="column"
        />
        <Flex w="100%" justifyContent="center" maxW={['100%', '100%', '126px']}>
          <Box
            minW={['80px', '80px', '110px']}
            minH={['80px', '80px', '110px']}
            maxWidth="120px"
            position="relative"
            display="flex"
            alignItems="center"
            mr={[0, 0, '16px !important']}
          >
            <Image src={clipboardIcon} alt="SOA icon" />
          </Box>
        </Flex>
        <Stack pt={[6, 6, 0]}>
          <Header as="h4">Scope of Appointment</Header>
          <Body1>Complete this so your agent can discuss plans at your upcoming appointment.</Body1>
          <Button width={['100%', '100%', 220]} href={Routes.accountSurveyUpdateSoa}>
            Complete SOA
          </Button>
        </Stack>
      </Stack>
    </DashboardCard>
  );
};
